
<div style="display: flex; justify-content: center; flex-direction: column;">
  <h1>kiosk-calls section</h1>
</div>